import { Box, Checkbox, FormControl, Typography } from "@mui/material";
import { useRef } from "react";

export default function CheckExperienceResidential({ data = [], checkedState = {}, onToggle, setChanges = () => {} }) {
  const boxRef = useRef(null);

  return (
    <Box sx={{ position: "relative", width: "100%" }}>
      <FormControl
        component="fieldset"
        sx={{ width: "100%", height: 250, overflowY: "auto", overflowX: "hidden", p: 0, display: "block" }}
        ref={boxRef}
      >
        {(data ?? []).map((item) => {
          const isChecked = !!checkedState?.[item.id];

          return (
            <Box
              key={item.id}
              onClick={() => {
                setChanges(true);
                onToggle(item.id, !isChecked);
              }}
              sx={{
                width: "calc(100% - 2px)",
                height: "50px",
                display: "flex",
                alignItems: "center",
                padding: "0 15px",
                marginBottom: "8px",
                borderRadius: "10px",
                cursor: "pointer",
                border: isChecked ? "1px solid #FF8C00 " : "1px solid transparent",
                boxSizing: "border-box",
                backgroundColor: isChecked ? "rgba(255, 140, 0, 0.05)" : "var(--fx-surface-base, #FFFFFF)",
                transition: "all 0.2s ease",
                "&:hover": {
                  borderColor: "#FF8C00",
                  bgcolor: isChecked ? "rgba(255, 140, 0, 0.08)" : "var(--fx-surface-sunken, #F8FAFC)",
                },
              }}
            >
              <Checkbox
                checked={isChecked}
                disableRipple
                sx={{
                  pointerEvents: "none",
                  padding: 0,
                  marginRight: "16px",
                  color: "#cbd5e1",
                  "&.Mui-checked": {
                    color: "#FF8C00",
                  },
                  "& .MuiSvgIcon-root": {
                    fontSize: 26,
                    borderRadius: "6px",
                  },
                }}
              />
              <Typography
                sx={{
                  fontSize: "0.85rem",
                  fontWeight: isChecked ? 700 : 500,
                  color: isChecked ? "var(--fx-surface-text, #0F172A)" : "var(--fx-surface-textsecondary, #64748B)",
                  userSelect: "none",
                }}
              >
                {item.workServices?.name}
              </Typography>
            </Box>
          );
        })}
      </FormControl>
      <Box
        sx={{
          position: "absolute",
          bottom: 0,
          left: 0,
          right: 0,
          height: "30px",
          pointerEvents: "none",
          background: "linear-gradient(to bottom, rgba(255,255,255,0) 0%, var(--fx-surface-sunken, #F8FAFC) 100%)",
          zIndex: 10,
        }}
      />
    </Box>
  );
}
